import { defineStore } from 'pinia'
import { ref } from 'vue'

type ToastData = {
  uid: string
  message: string
  mode: 'success' | 'warn' | 'error'
}

const generateTimestampBasedUID = () => {
  // 現在のタイムスタンプを取得
  const timestamp = Date.now();

  // 0~9999のランダムな文字列を生成
  const randomComponent = Math.floor(Math.random() * 10000).toString().padStart(4, '0');

  // タイムスタンプとランダムな文字列を組み合わせてIDを生成
  return `${timestamp}-${randomComponent}`;
}

export const useToastStore = defineStore('toast', () => {
  const toasts = ref<Record<string, ToastData>>({})

  const setToast = (data: Omit<ToastData, 'uid'>) => {
    const uid = generateTimestampBasedUID()
    toasts.value[uid] = {
      ...data,
      uid
    }

    // 自動削除
    setTimeout(() => {
      delete toasts.value[uid]
    }, 4000)
  }

  return {
    toasts,
    setToast,
  }
})

export type ToastStore = ReturnType<typeof useToastStore>
